(function ( $, window, document, undefined ) {
	
    $.fn.mainNav = function ( options ) {

		// Default settings
        var settings = $.extend({}, $.fn.mainNav.settings, options);

        return this.each(function() {
            $container = $(this); /* Navigation container: #mainNav-container */
            $toggle = $container.find( "#mainNav-toggle" );
            $mainNav = $container.find( "#mainNav-menu" );
            $window = $( window );
            
            $container.addClass(settings.responsiveFrom);
            $toggle.addClass(settings.responsiveFrom);
            var isBreakpoint;
            breakpointChk();

            // Overlay
            if ( settings.hasOverlay ) {
                if ( $('.mainNavOverlay').length == 0 ) {
                    $('body').append("<div class='mainNavOverlay'></div>");
                    $(".mainNavOverlay").css({
                        "top":                 "0",
                        "right":               "0",
                        "bottom":              "0",
                        "left":                "0",
                        "position":            "fixed",
                        "background-color":    settings.overlayColor,
                        "opacity":             settings.opacity,
                        "z-index":             "999",
                        "display":             "none"

                    });
                }
            }

            // Sticky Nav
            if ( settings.stickyNav ) {
                var navPosition = $mainNav.offset().top;
                stickyNavChk(navPosition);
                $( window ).scroll(function () {
                    stickyNavChk(navPosition);
                });
            }

            // Push Navigation
            if ( settings.pushNav ) {
                $pushNav = $( '.push-mainNav-container' );
                $pushNav.addClass(settings.responsiveFrom);
                $('#mainNav-toggle, .mainNavOverlay').on('click', function () {
                    $pushNav.toggleClass('push-mainNav-open');
                    $('#mainNav-menu li').removeClass('mainNav-dropdown-open');
                });
            }

            // Toggle click event
            $('#mainNav-toggle, .mainNavOverlay').on('click', function () {
                $('#mainNav-toggle').stop().toggleClass('mainNav-open');
                $container.stop().toggleClass('mainNav-open');
                $('.mainNavOverlay').fadeToggle();
            });

            // Dropdown
            if ( $toggle.is(":visible") ) {
                $('#mainNav-menu li').has('ul').on('click', function (e) {
                if (e.target != this) return;
                $(this).toggleClass('mainNav-dropdown-open');
            });
            $('#mainNav-menu li > a').on('click', function () {
                $(this).parent().toggleClass('mainNav-dropdown-open');
            });

        } // End return

        var resizeTimer;
        $(window).resize(function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                breakpointChk();
                if ( isBreakpoint ) {
                    $('body').css("margin-top", "0px");
                    if( $toggle.hasClass('mainNav-open') ){
                        $('.mainNavOverlay').css("display","block");
                    }
                } else {
                    $('.mainNavOverlay').css("display","none");
                    navPosition = $mainNav.offset().top;
                    stickyNavChk(navPosition);
                }
            }, 500);
        });

        /* Functions */
        function breakpointChk() {
            if ($toggle.is(":visible")) {
                isBreakpoint = true;
                console.log("isBreakpoint");
            } else {
                isBreakpoint = false;
                console.log("not isBreakpoint");
            }
        }

        function stickyNavChk(navPosition) {
            if ( $toggle.is(":hidden") && settings.stickyNav ) {
                if ($window.scrollTop() > navPosition) {
                    $container.addClass("mainNav-sticky");
                    // Add margin to the top of the body to avoid window "jumping"
                    $('body').css("margin-top", "0px");
                    // Wrap navigation into sticky container
                    if ($('.sticky-mainNav-container').length <= 0) {
                        $toggle.next().andSelf().wrapAll("<div class='sticky-mainNav-container'></div>");
                    }
                } else {
                    if ($('.sticky-mainNav-container').length > 0) {
                        $('body').css("margin-top", "0");
                        $container.removeClass("mainNav-sticky");
                        $('.sticky-mainNav-container > *').unwrap();
                    }
                }
            } else {
                if ( $window.scrollTop() == 0 ) {
                    $('body').css("margin-top", "0");
                    $container.removeClass("mainNav-sticky");
                    $('.sticky-mainNav-container > *').unwrap();
                }
            }
        }

	});
};


    // Default settings
    $.fn.mainNav.settings = {
        responsiveFrom: "left",  /* left || right || top */
        stickyNav: false,
        pushNav: false,
        hasOverlay: true,
        overlayColor: "#000",
        opacity: ".7"
    };

	

})( jQuery, window, document);